<template lang='pug'>
 .basic-unit-price
    button#basic-unit-price-filter
      span {{ $t('competitors_filters.basic_unit_price') }}
      span#checked-basic-unit-price {{ viewFormattedFilter }}
    b-popover(ref="filter_popover" target='basic-unit-price-filter' triggers='click blur' placement='bottomright')
      .basic-unit-price-filter-list-wrapper
        .form-wrapper
          .inputs
            b-form-select(
              v-model='lowerEdge' 
              :options='selectLowerEdge' 
              size='sm' 
              @change='changedFilter'
            )
            span.delimiter -
            b-form-select(
              v-model='higherEdge' 
              :options='selectHigherEdge' 
              size='sm' 
              @change='changedFilter'
            )
          #error-message(v-if='errorMessage')
           span {{ errorMessage }}
      button.view-search-results(@click="validateSearchResult") {{ $t('competitors_filters.view_search_results') }}
</template>

<script>
  import applyFilter from '@/mixins/apply-filter'
  import formattedFilter from '@/mixins/formatted-filter'
  import rangeFilter from '@/mixins/range-filter'
  import { range, zipObject } from 'lodash'

  export default {
    mixins: [
      applyFilter,
      formattedFilter,
      rangeFilter
    ],

    props: {
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: -1
      }
    },

    data() {
      return {
        lowerEdge: this.min,
        higherEdge: this.max,
        errorMessage: ''
      }
    },

    computed: {
      rangeBy1000() {
        return range(1000, 30100, 1000)
      },

      selectLowerEdge() {
        return {
          0: this.$t('competitors_filters.no_lower_limit'),
          ...zipObject(this.rangeBy1000, this.rangeBy1000)
        }
      },

      selectHigherEdge() {
        return {
          ...zipObject(this.rangeBy1000, this.rangeBy1000),
          [-1]: this.$t('competitors_filters.no_higher_limit')
        }
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import '@/assets/css/mixins/competitors/filter.scss';

  .basic-unit-price {
    #basic-unit-price-filter {
      @include button-item-filter;

      #checked-basic-unit-price {
        @include span-checked-item;
      }
    }
  }

  .basic-unit-price-filter-list-wrapper {
    .form-wrapper {
      @include range-form-wrapper;
    }
  }

  .view-search-results {
    @include view-search-results;
  }
</style>
